import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-semibold mb-4">Video Book Review Specialist</h4>
            <p className="text-slate-400 text-sm">CPD accredited training for video book review professionals.</p>
            <div className="flex space-x-4 mt-4">
              <a 
                href="https://www.facebook.com/groups/449766771396718/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-blue-400 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.youtube.com/@dianeshaweauthor" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-red-500 transition-colors"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/enroll" className="hover:text-white transition-colors">Enroll Now</Link></li>
              <li><Link to="/student-login" className="hover:text-white transition-colors">Student Login</Link></li>
              <li><Link to="/become-a-video-book-review-specialist" className="hover:text-white transition-colors">Training Program</Link></li>
              <li><Link to="/book-video-reviews-for-authors" className="hover:text-white transition-colors">For Authors</Link></li>
              <li><Link to="/blog-insights" className="hover:text-white transition-colors">Blog & Insights</Link></li>
              <li><Link to="/about-developer" className="hover:text-white transition-colors">About the Developer</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Sale</Link></li>
              <li><Link to="/support" className="hover:text-white transition-colors">Contact Support</Link></li>
              <li><Link to="/admin/login" className="hover:text-white transition-colors">Admin Login</Link></li>
              <li><a href="/sitemap.xml" className="hover:text-white transition-colors">Sitemap</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <p className="text-slate-400 text-sm">info@virtualautochat.uk</p>
            <p className="text-slate-400 text-sm">bookreviewspecialists.app</p>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; 2026 Video Book Review Specialist. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
